<template>
  <div class="l-col-12@md" v-if="verifyShippingRule(selectedShippingOption) && announcementConfiguration.shippingFree">
    <strong>Em caso de frete grátis, escolha a regra:</strong>
    <loader :loading="loading" v-if="loading"/>
    <div v-for="shippingRule in shippingRules" :key="shippingRule" v-if="Object.keys(shippingRules).length && !loading"
         class="l-row">
      <form-group :label="getLabel()" :columns="4">
        <radio-button :options="getShippingRuleOptions(shippingRule)" :checkedDefault="shippingRuleSelected" :toggleChecked="onChangeShippingRule"
                      :name="announcementConfiguration.account.identifier"/>
      </form-group>

      <form-group label="Regiões não atendidas" v-if="shippingRuleSelected === 'exclude_region' ">
        <multiselect
            v-model="shippingRuleSelectedRegion"
            :options="regions"
            selectLabel=""
            selectedLabel=""
            placeholder="Escolha"
            :multiple="true"
        />
      </form-group>
    </div>
  </div>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import Multiselect from 'vue-multiselect'
  import { mapFields } from 'vuex-map-fields'
  import RadioButton from '@/components/template/RadioButton'
  import api from '@/api'
  import Loader from '@/components/template/Loader'
  import notifier from '@/notifier'

  export default {
    data: () => ({
      regions: [],
      shippingRules: [],
      acceptedMethods: [],
      defaultRule: false,
      shippingRuleSelected: 'country',
      shippingRuleSelectedRegion: [],
      loading: false
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      announcementConfiguration: {
        type: Object,
        required: true
      },
      selectedShippingOption: {
        type: String,
        required: true
      },
      accountQuantity: {
        type: Number,
        required: true
      }
    },
    async created () {
      await this.getShippingRules()
    },
    methods: {
      getLabel () {
        if (this.accountQuantity > 1) {
          return `${this.announcementConfiguration.account.name} (${this.announcementConfiguration.account.nickname})`
        }
      },
      getShippingRuleOptions (shippingRule) {
        const optionsRules = []

        for (const logisticTypes of shippingRule.logistic_types) {
          this.acceptedMethods = logisticTypes.attributes.free.accepted_methods
          for (const freeRules of logisticTypes.attributes.free.rules) {
            if (freeRules.free_mode === 'exclude_region' || freeRules.free_mode === 'country') {
              optionsRules.push({
                code: freeRules.free_mode,
                label: this.$t(`mercadoLivre.shippingRules.${freeRules.free_mode}.label`)
              })

              this.defaultRule = freeRules.default

              if (freeRules.free_mode === 'exclude_region') {
                this.regions = freeRules.value
              }
            }
          }
        }
        return optionsRules
      },
      onChangeShippingRule (identifier, code) {
        this.shippingRuleSelected = code
        this.product.shippingFreeRule[identifier] = {
          rule: this.shippingRuleSelected,
          acceptedMethods: this.acceptedMethods,
          default: this.defaultRule
        }
      },
      async getShippingRules () {
        this.loading = true

        const categoryId = this.product.categories.slice(-1)[0]

        if (this.announcementConfiguration && this.announcementConfiguration.account && categoryId) {
          const dimensions = `${this.product.variations[0].height}x${this.product.variations[0].width}x${this.product.variations[0].length},${this.product.variations[0].weight}`
          try {
            this.shippingRules = await api.mercadoLivre.getShippingRules(categoryId, this.announcementConfiguration.account.identifier, dimensions)
          } catch (err) {
            return notifier.error('Não foi possível carrefas as formas de envio da categoria!', 'Configurar regras de publicação')
          }
        }
        this.loading = false
      },
      verifyShippingRule (shippingOption) {
        if (!this.shippingRules || !Array.isArray(this.shippingRules)) {
          this.product.shippingFreeRule[this.announcementConfiguration.account.identifier] = []
          return false
        }

        for (const shipping of this.shippingRules) {
          if (shipping.mode === shippingOption) {
            if (shipping.logistic_types && shipping.logistic_types.length > 0) {
              return true
            }
          }
        }

        this.product.shippingFreeRule[this.announcementConfiguration.account.identifier] = []
        return false
      }
    },
    watch: {
      shippingRuleSelectedRegion () {
        this.product.shippingFreeRule[this.announcementConfiguration.account.identifier] = {
          rule: this.shippingRuleSelected,
          ruleRegion: this.shippingRuleSelectedRegion,
          acceptedMethods: this.acceptedMethods,
          default: this.defaultRule
        }
      },
      account: {
        handler: function () {
          this.getShippingRules()
        },
        deep: true
      },
      'product.categories': {
        handler: function () {
          this.getShippingRules()
        },
        deep: true
      },
      loading () {
        this.$emit('loading', this.loading)
      }
    },
    computed: {
      ...mapFields({
        accounts: 'mercadoLivreAccounts.accounts'
      })
    },
    components: {
      Loader,
      Panel,
      FormGroup,
      Multiselect,
      RadioButton
    }
  }
</script>

<style lang="sass" scoped>
  strong
    display: block
    margin-bottom: 5px

    .margin
      margin: 10px 0 15px 10px
</style>



// WEBPACK FOOTER //
// ShippingRules.vue?6927e7b6